import React from 'react'
import useTrans from '@hooks/useTrans'
import { cn, priceValutaNotation } from '@utils/safeTs'
import styles from './TotaleCosti.module.sass'
import { useSelector } from 'react-redux'
import { RootStateType } from '@utils/types'

export interface TotaleCostiProps {
  item: {
    valoreMerce?: number
    valorePersonalizzazione?: number
    valoreConfezionamento?: number
    valoreImpianto?: number
    valoreTracciaturaLogo?: number
    valoreSupplementiMinimiDiStampa?: number // per la bolla
    valoreGestione?: number
    valoreScontoImballi?: number
    valoreScontoMerce?: number
    valoreScontoPersonalizzazione?: number
    valoreScontoGestione?: number
    valoreScontoImpianto?: number
    valoreScontoTrasporto?: number
    valoreTrasporto?: number
    valoreSpeseSiae?: number
    totaleImponibile?: number
    totaleIva?: number
    totaleDocumento?: number
    // SG
    valoreScontoImballiIntegri?: number
    valoreSupplementiMinimiStampa?: number 
    valoreSiae?: number
  }
  className?: string
}

const TotaleCosti = ({ item, className = '' }: TotaleCostiProps) => {

  const t = useTrans()
  const { service_gift } = useSelector((state: RootStateType) => state.servicegift) 

  const list = [
    { key: 'totale_prodotti', label: t("Totale prodotti"), value: item.valoreMerce, precision: 3 }, 
    { key: 'personalizzazione', label: t("Personalizzazione"), value: item.valorePersonalizzazione, precision: 3 }, 
    { key: 'personalizzazione_altri', label: t("Altri costi personaliz."), precision: 3, children: [
      { key: 'altri_confezionamento', label: t("Confezionamento"), value: item.valoreConfezionamento, precision: 3 },
      { key: 'altri_impianti', label: t("Impianti"), value: item.valoreImpianto, precision: 2 },
      { key: 'altri_tracciaturalogo', label: t("Tracciatura Logo"), value: item.valoreTracciaturaLogo, precision: 2 },
      { key: 'altri_supplementiminimistampa', label: t("Supplementi minimi di stampa"), value: item.valoreSupplementiMinimiStampa || item.valoreSupplementiMinimiDiStampa, precision: 2 },
      { key: 'altri_avviamento', label: t("Avviamento"), value: item.valoreGestione, precision: 2 },
    ]},
    { key: 'sconti', label: t(service_gift ? "Sconto" : "Sconti"), value: null, precision: 3, children: service_gift ? [ // Qui pare non ci va il totale - forzo value: null
      { key: 'sconti_imballi', label: t("Sconto Imballi"), value: item.valoreScontoImballiIntegri, precision: 2 },
    ] : [ 
      { key: 'sconti_imballi', label: t("Sconto Imballi"), value: item.valoreScontoImballi, precision: 2 },
      { key: 'sconti_merceneutra', label: t("Sconto Merce Neutra"), value: item.valoreScontoMerce, precision: 2 },
      { key: 'sconti_personalizzazione', label: t("Sconto personalizzazione"), value: item.valoreScontoPersonalizzazione, precision: 2 },
      { key: 'sconti_avviamento', label: t("Sconto avviamento"), value: item.valoreScontoGestione, precision: 2 },
      { key: 'sconti_impianti', label: t("Sconto impianti"), value: item.valoreScontoImpianto, precision: 2 },
      { key: 'sconti_spedizione', label: t("Sconto spedizione"), value: item.valoreScontoTrasporto, precision: 2 },
    ]},
    { key: 'spedizione', label: t("Spedizione"), value: item.valoreTrasporto, precision: 2 },
    { key: 'siae', label: t("Spese SIAE"), value: service_gift ? item.valoreSiae : item.valoreSpeseSiae, precision: 2 },
    { key: 'totale_netto', label: t("Totale netto"), value: item.totaleImponibile, precision: 2 },
    { key: 'iva', label: t("IVA"), value: item.totaleIva, precision: 2 },
  ]
    .filter(x => !!x.value || x.children?.filter(y => !!y.value)?.length)
    .map(x => ({...x, value: 'value' in x ? x.value : x?.children?.reduce((sum, y) => sum + y.value || 0, 0)}))

  return (
    <div className={cn(styles.root, className)}>
      {list.map(
        x => (
          <React.Fragment key={x.key}>
            <div className={styles.item}>
              <p className={styles.itemLabel}>{x.label}</p>
              {x.value && (
                <p className={styles.itemValue}>
                  {priceValutaNotation(x.value, x.precision)}
                </p>
              )}
            </div>
            {x.children?.filter(y => !!y.value).map(y => (
              <div className={styles.subitem} key={y.key}>
                <p className={styles.subitemLabel}>
                  {y.label}
                </p>
                <p className={styles.subitemValue}>
                  {priceValutaNotation(y.value, y.precision)}
                </p>
              </div>
            ))}
          </React.Fragment>
        )
      )}
      <div className={styles.item}>
        <p className={styles.itemLabel}>
            {t("TOTALE")}
        </p>
        <p className={styles.itemValue}>
          {priceValutaNotation(item.totaleDocumento, 2)}
        </p>
      </div>
    </div>
  )
}

export default TotaleCosti
